export const messages = {"CRATE_LEBENSLAUF_PREVIEW_BUTTON":"Vorschau"};